import api from "@/lib/api";

// After an address is picked, ask who trades there (Business Directory, then Google Maps) and fill in the business name/contact.
export async function enrichWithBusiness(addr) {
  if (!addr?.lat || addr.business) return addr;
  try {
    const { data } = await api.get("/address/business-at", { params: { lat: addr.lat, lng: addr.lng } });
    if (!data?.business) return addr;
    return {
      ...addr, business: data.business,
      contact_name: addr.contact_name || data.contact_name || "",
      contact_phone: addr.contact_phone || data.contact_phone || "",
      business_instructions: data.instructions || "",
      business_source: data.source,
      business_candidates: (data.candidates || []).filter((c) => c.business !== data.business),
    };
  } catch { return addr; }
}
